<template>
  <div class="pay-result">
    <div class="logo">
      <img src="../../../assets/images/img/artemisads-logo.svg" />
    </div>
    <div class="content-wrap">
      <div class="content">
        <div class="success" v-if="status === 'success'">
          <span class="duigou">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-duigou-jiacu"></use>
            </svg>
          </span>
          <p class="payment">{{ st('payResult.paymentSubmittedSuccess') }}</p>
          <p class="you-may">{{ st('payResult.mayClosePage') }}</p>
          <artmisads-button @click="() => toHome()">{{ st('payResult.backToArtemisAds') }}</artmisads-button>
        </div>
        <div class="pending" v-if="status === 'pending'">
          <div class="icon-wrap">
            <span class="duigou">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-duigou-jiacu"></use>
              </svg>
            </span>
            <span class="line"></span>
            <span class="loading">
              <LoadingOutlined :style="{ fontSize: '24px' }" />
            </span>
          </div>
          <div class="text-wrap">
            <p class="payment">{{ st('payResult.paymentSubmittedSuccess') }}</p>
            <span>{{ st('payResult.waitPaypalConfirm') }}</span>
            <p class="bill">{{ st('payResult.billInProgress') }}</p>
          </div>
        </div>
        <div class="failed" v-if="status === 'fail'">
          <span class="duigou">
            <svg class="icon close" aria-hidden="true">
              <use xlink:href="#icon-close-cu"></use>
            </svg>
          </span>
          <p class="payment">{{ st('payResult.paymentFailed') }}</p>
          <p class="you-may">{{ st('payResult.tryAgainContact') }}</p>
          <artmisads-button @click="() => toHome()">{{ st('payResult.backToArtemisAds') }}</artmisads-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import { financeApi } from '@/server';
import { useRouter } from 'vue-router';
import { LoadingOutlined } from '@ant-design/icons-vue';
import { useSellerI18n } from '@/composables/useSellerI18n';

const { st } = useSellerI18n();

let times = 19; // 请求次数, 20次后不管是否成功都算完成
let timer = null;
const status = ref(''); // 初始状态设为空, 否则页面会闪
const requestId = ref('');
const router = useRouter();
const spinning = ref(false);
const orderFinished = ref(false); // 订单是否完成, 除了PENDING都算完成

async function getPayResult() {
  if (requestId.value) {
    spinning.value = true;

    const res = await financeApi.getPayResult(requestId.value);

    let { data, success } = res;

    if (success) {
      data = data.toLowerCase();
      status.value = data;

      if (data == 'success' || data == 'fail') {
        spinning.value = false;
        orderFinished.value = true;
        timer && clearInterval(timer);
        data == 'success' && localStorage.removeItem('SELLER_ORDER_REQUESTID');
      }
    }

    times -= 1;

    if (!orderFinished.value && times <= 0) {
      clearInterval(timer);
      spinning.value = false;
    }
  }
}

onMounted(() => {
  requestId.value = localStorage.getItem('SELLER_ORDER_REQUESTID');

  if (requestId.value) {
    getPayResult();

    if (!orderFinished.value) {
      timer = setInterval(getPayResult, 5000);
    }
  }
})

const toHome = () => {
  if (window.opener) {
    // 刷新上一个页面
    window.opener.location.reload();
  }

  const { href } = router.resolve({ path: `/seller/finance/payments` });
  window.open(href, '_self');
}
</script>
<style lang="less" scoped>
.pay-result {
  width: 100%;

  .logo {
    margin-top: 24px;
    margin-left: 28px;

    img {
      width: 176px;
      height: 40px;
    }
  }

  .content-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 98px;
  }

  .content {
    width: 720px;
    height: 476px;
    background: var(--color-white);
    box-shadow: var(-section-box-shadow-5);
    border-radius: 8px;
  }

  .success,
  .failed {
    display: flex;
    flex-direction: column;
    padding-top: 140px;

    .duigou {
      display: flex;
      background-color: var(--green-3);
      width: 64px;
      height: 64px;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      border: 6px solid var(--green-9);
      align-self: center;

      svg {
        width: 32px;
        height: 32px;
        align-self: center;
        fill: var(--green-7);
      }
    }

    .payment {
      font-weight: 600;
      font-size: 20px;
      color: var(--dark-1);
      letter-spacing: 0.5px;
      text-align: center;
      line-height: 30px;
      margin-top: 15px;
    }

    .you-may {
      margin-top: 7px;
      font-weight: 500;
      font-size: 16px;
      color: var(--dark-2);
      letter-spacing: 0.4px;
      text-align: center;
      line-height: 24px;
    }

    >button {
      width: 217px;
      align-self: center;
      margin-top: 16px;
    }
  }

  .failed {
    .duigou {
      background: var(--error-1);
      border: 6px solid var(--error-2);

      svg.close {
        fill: #fff;
      }
    }
  }

  .pending {
    display: flex;
    padding-top: 128px;
    padding-left: 136px;

    .icon-wrap {
      display: flex;
      flex-direction: column;
      width: 56px;

      .line {
        height: 101px;
        width: 4px;
        background-color: var(--bg-gray-10);
        align-self: center;
      }

      .duigou {
        display: flex;
        background-color: var(--green-9);

        svg {
          width: 32px;
          height: 32px;
          align-self: center;
          fill: var(--green-3);
        }
      }

      .loading {
        background-color: var(--bg-gray-10);

        :deep(svg) {
          fill: var(--primary-text);
        }
      }

      .loading,
      .duigou {
        width: 56px;
        height: 56px;
        border-radius: 100%;
        display: flex;
        justify-content: center;
      }
    }

    .text-wrap {
      display: flex;
      flex-direction: column;
      margin-left: 20px;

      >span {
        font-weight: 500;
        font-size: 16px;
        color: var(--dark-3);
        letter-spacing: 0.4px;
        line-height: 24px;
        margin-top: 7px;
      }

      >p {
        font-weight: 600;
        font-size: 20px;
        color: var(--dark-1);
        letter-spacing: 0.5px;
        line-height: 30px;
      }

      .payment {
        margin-top: 5px;
      }

      .bill {
        margin-top: 108px;
      }
    }
  }
}
</style>
